var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-modal",
    {
      attrs: {
        modalNova: true,
        closeOutside: false,
        titulo:
          "Vincular processo " + (_vm.isCertidao ? "a Certidão" : "ao Título"),
        width: 700
      },
      on: {
        closeModal: function($event) {
          return _vm.closeModal()
        }
      }
    },
    [
      _c(
        "template",
        { slot: "body" },
        [
          _c(
            "validation-observer",
            { ref: "observer" },
            [
              _c("validation-provider", {
                attrs: { rules: "required" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("div", { staticClass: "document-name-container" }, [
                          _c("span", { staticClass: "document-name" }, [
                            _vm._v(_vm._s(_vm.nomeDocumento))
                          ]),
                          _c("hr")
                        ]),
                        _c(
                          "el-row",
                          { staticClass: "flex" },
                          [
                            _c("app-label", {
                              attrs: {
                                label: "Informe o número do processo:",
                                required: true
                              }
                            }),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  placement: "top-start",
                                  "open-delay": 500
                                }
                              },
                              [
                                _c("template", { slot: "content" }, [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(_vm.getTextoTooltip)
                                    }
                                  })
                                ]),
                                _c("font-awesome-icon", {
                                  staticClass: "icon-info",
                                  attrs: { icon: "info-circle" }
                                })
                              ],
                              2
                            )
                          ],
                          1
                        ),
                        _c("el-input", {
                          directives: [
                            {
                              name: "mask",
                              rawName: "v-mask",
                              value: ["#########/####"],
                              expression: "['#########/####']"
                            }
                          ],
                          staticClass: "input width-50",
                          class: { erro: errors.length },
                          attrs: { disabled: _vm.showPesquisar, type: "text" },
                          nativeOn: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.consultar($event)
                            }
                          },
                          model: {
                            value: _vm.campo,
                            callback: function($$v) {
                              _vm.campo = $$v
                            },
                            expression: "campo"
                          }
                        }),
                        _c("br"),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ]),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.notificacao,
                                expression: "notificacao"
                              }
                            ],
                            staticClass: "error-message"
                          },
                          [_vm._v(_vm._s(_vm.$messages.VINCULAR_PROCESSO))]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.processo.tipo.nome,
                  expression: "processo.tipo.nome"
                }
              ],
              staticClass: "margin-top"
            },
            [
              _c("app-label", { attrs: { label: "Tipo do processo:" } }),
              _c("el-input", {
                staticClass: "input width-50",
                attrs: { type: "text", disabled: true },
                model: {
                  value: _vm.processo.tipo.nome,
                  callback: function($$v) {
                    _vm.$set(_vm.processo.tipo, "nome", $$v)
                  },
                  expression: "processo.tipo.nome"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.processo.nomeRazaoSocialInteressado,
                  expression: "processo.nomeRazaoSocialInteressado"
                }
              ],
              staticClass: "margin-top"
            },
            [
              _c("app-label", {
                attrs: { label: "Nome/Razão Social do Interessado:" }
              }),
              _c("el-input", {
                staticClass: "input width-50",
                attrs: { type: "text", disabled: true },
                model: {
                  value: _vm.processo.nomeRazaoSocialInteressado,
                  callback: function($$v) {
                    _vm.$set(_vm.processo, "nomeRazaoSocialInteressado", $$v)
                  },
                  expression: "processo.nomeRazaoSocialInteressado"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.processo.cpfCnpjInteressado,
                  expression: "processo.cpfCnpjInteressado"
                }
              ],
              staticClass: "margin-top"
            },
            [
              _c("app-label", { attrs: { label: "CPF/CNPJ do Interessado:" } }),
              _c("el-input", {
                staticClass: "input width-50",
                attrs: { type: "text", disabled: true },
                model: {
                  value: _vm.processo.cpfCnpjInteressado,
                  callback: function($$v) {
                    _vm.$set(_vm.processo, "cpfCnpjInteressado", $$v)
                  },
                  expression: "processo.cpfCnpjInteressado"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.processo.setor,
                  expression: "processo.setor"
                }
              ],
              staticClass: "margin-top"
            },
            [
              _c("app-label", { attrs: { label: "Setor atual:" } }),
              _c("el-input", {
                staticClass: "input width-50",
                attrs: { type: "text", disabled: true },
                model: {
                  value: _vm.processo.setor,
                  callback: function($$v) {
                    _vm.$set(_vm.processo, "setor", $$v)
                  },
                  expression: "processo.setor"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.processo.status,
                  expression: "processo.status"
                }
              ],
              staticClass: "margin-top"
            },
            [
              _c("app-label", { attrs: { label: "Situação atual" } }),
              _c("el-input", {
                staticClass: "input width-50",
                attrs: { type: "text", disabled: true },
                model: {
                  value: _vm.statusFormatado,
                  callback: function($$v) {
                    _vm.statusFormatado = $$v
                  },
                  expression: "statusFormatado"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("template", { slot: "footer" }, [
        _c(
          "div",
          { staticClass: "buttons" },
          [
            _c(
              "el-button",
              {
                key: "botao-cancelar",
                attrs: { type: "default" },
                on: {
                  click: function($event) {
                    return _vm.closeModal()
                  }
                }
              },
              [_vm._v("Cancelar")]
            ),
            !_vm.processo.cpfCnpjInteressado
              ? _c(
                  "el-button",
                  {
                    key: "botao-pesquisa",
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.consultar()
                      }
                    }
                  },
                  [_vm._v("Pesquisar")]
                )
              : _vm._e(),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.processo.cpfCnpjInteressado,
                    expression: "processo.cpfCnpjInteressado "
                  }
                ],
                key: "botao-confirma",
                attrs: { type: "primary", disabled: !_vm.showIncluir },
                on: {
                  click: function($event) {
                    return _vm.incluir()
                  }
                }
              },
              [_vm._v("Incluir")]
            )
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-61803ee3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61803ee3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/assinatura/VincularProcesso.vue
// module id = null
// module chunks = 